module.exports = __webpack_public_path__ + "img/Detail_thumbnail.7d4097fd.jpg";